import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Icon } from "@iconify/react";

interface NotificationPopupProps {
  show: boolean;
  message: string;
  onClose: () => void;
}

export const NotificationPopup: React.FC<NotificationPopupProps> = ({ show, message, onClose }) => {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
          className="fixed top-20 right-4 z-50 bg-content3/95 backdrop-blur-md border border-divider shadow-md p-4 max-w-xs w-full flex items-start gap-3"
        >
          <div className="bg-primary/5 p-2 rounded-full">
            <Icon icon="lucide:bell" className="text-foreground/80" width={18} />
          </div>
          <div className="flex-grow">
            <p className="text-sm text-foreground/90">{message}</p>
          </div>
          <button onClick={onClose} className="text-foreground/60 hover:text-foreground">
            <Icon icon="lucide:x" width={16} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};